export default __webpack_public_path__ + "static/0021-6183e9e285249a58a4d4ef6e5dce38e1.png";